module.exports = __webpack_public_path__ + "static/media/airbtics_pro_uk_cover.76d24d27.jpg";